import { createAsyncThunk } from '@reduxjs/toolkit';

import { DefaultPathEnum } from '../../../../main/constants/default-path.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { AppStateEnum } from '../../../../main/types/app-state.types.ts';
import { getAudioPlayerUtil } from '../../../../main/utils/audio/audio-player.util.ts';
import { getLocaleUtil } from '../../../../main/utils/locale.util.ts';
import { getUrlUtil } from '../../../../main/utils/url.util.ts';

import { STEP_RESTART_TRANSITION_DELAY_MS } from '../../../constants/app-state-transition-delays.ts';
import { selectCurrentLessonCharacter } from '../../../selectors/current-lesson-character.selector.ts';

import { updateAppStateThunk } from '../../app-state/thunks/update-app-state.thunk.ts';

import { LESSON_SLICE_NAME } from '../lesson.slice.types.ts';

import { abortCurrentStepThunk } from './abort-current-step.thunk.ts';

const THUNK_NAME = `${LESSON_SLICE_NAME}/restartCurrentStepThunk`;

interface Props {
  shouldSpeakRestartMessage?: boolean;
}

export const restartCurrentStepThunk = createAsyncThunk<void, Props | undefined, ThunkApiConfigType>(
  THUNK_NAME,
  async (props = {}, thunkAPI): Promise<void> => {
    const { shouldSpeakRestartMessage = false } = props;

    const state = thunkAPI.getState();
    await thunkAPI.dispatch(abortCurrentStepThunk()).unwrap();

    const audioPlayerUtil = getAudioPlayerUtil();
    await audioPlayerUtil.waitForPlaybackStopped();

    if (shouldSpeakRestartMessage) {
      const localeUtil = getLocaleUtil();

      const character = selectCurrentLessonCharacter(state);
      const message = localeUtil.select('learn:step_restart_message');

      audioPlayerUtil.speak(message, character);
      await audioPlayerUtil.waitSpeakCompletion();
    }
    const currentPath = getUrlUtil().getPathname();
    if (currentPath === (DefaultPathEnum.LEARN_SCREEN as string)) {
      await thunkAPI
        .dispatch(updateAppStateThunk({ state: AppStateEnum.ReadyToStart, delay: STEP_RESTART_TRANSITION_DELAY_MS }))
        .unwrap();
    }
  }
);
